import { extendTheme } from "@chakra-ui/react";

const theme = {
  fonts: {
    heading: `'Montserrat', sans-serif`,
  },
};

export default extendTheme(theme);
